<template lang="">
  <div
    style="height: 100vh;"
    class="d-flex justify-center flex-column align-center"
  >
    <div
      class="d-flex align-center justify-between ma-4"
      style=" width: 100%;max-width: 750px"
    >
      <!-- <v-text-field
        placeholder="User id"
        class="message-input mr-4"
        solo
        v-model="userId"
      ></v-text-field> -->
      <v-text-field
        placeholder="Patient ID (number)"
        class="patient-id-input mr-4"
        solo
        type="text"
        v-model="patientId"
      ></v-text-field>
      <v-btn color="error" elevation="0" @click="clearContext"
        >Clear Context</v-btn
      >
    </div>
    <v-card class="chat-container " max-width="100%" width="750px">
      <div ref="chatBox" class="chat-box pa-4">
        <div class="d-flex" v-for="(message, i) in messages" :key="i">
          <v-spacer v-if="message.sent"></v-spacer>

          <v-alert
            :icon="message.sent ? 'mdi-account' : 'mdi-robot'"
            :color="message.sent ? 'primary ' : 'secondary '"
            style="word-break: break-all;color: white;"
          >
            {{ message.sent || message.received }}
          </v-alert>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center justify-between send-text-box pa-4">
        <v-text-field
          placeholder="Aa"
          class="message-input mr-4"
          solo
          @keyup.enter="sendText"
          v-model="message"
        ></v-text-field>
        <v-btn icon color="info" @click="sendText">
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      messages: [],
      message: "",
      userId: 1258089477,
      name: "User",
      patientId: "",
      demoPatientId: 999,
    };
  },

  mounted() {
    //Check if local storage is available
    // Get data from local storage when we decide to use the feature start from node and get the patientID
    let chatData;
    if (typeof Storage !== "undefined") {
      chatData = JSON.parse(localStorage.getItem("chatData"));
      const storedPatientId = localStorage.getItem("patientId");
      if (storedPatientId) {
        this.patientId = storedPatientId;
      }
    }
    // Handle messages
    if (chatData) {
      for (let i = 0; i < chatData.messages.length; i++) {
        const message = chatData.messages[i];

        this.messages.push({
          received: message,
        });
      }

      if (chatData.isEnd) {
        this.messages.push({
          received: "CONVERSATION_ENDED",
        });
      }
    }
    // Clear local storage
    if (typeof Storage !== "undefined") {
      localStorage.removeItem("chatData");
    }
  },
  methods: {
    sendText() {
      if (!this.message) {
        return;
      }

      const thisMessage = this.message;
      this.message = "";

      this.messages.push({
        sent: thisMessage,
      });

      //Store patient ID in locale storage
      if (typeof Storage !== "undefined") {
        if (this.patientId) {
          localStorage.setItem("patientId", this.patientId);
        } else {
          localStorage.removeItem("patientId");
        }
      }

      const patientId = this.patientId ? this.patientId : this.demoPatientId;

      this.$http
        .post(
          `/projects/${this.$route.params.id}/chat/${this.userId}/patient/${patientId}`,
          {
            text: thisMessage,
          }
        )
        .then(({ data }) => {
          for (let i = 0; i < data.messages.length; i++) {
            const message = data.messages[i].message;

            this.messages.push({
              received: message,
            });
          }

          if (data.isEnd) {
            this.messages.push({
              received: "CONVERSATION_ENDED",
            });
          }

          this.$nextTick(() => {
            this.$refs.chatBox.scrollTo(0, this.$refs.chatBox.scrollHeight);
          });

          const sentMessages = this.messages.map((x) => x.sent);
          /* if (sentMessages.length == 1){
            this.messages.push(
                {received: "Please think to start the story."},
                {received: "CONVERSATION_ENDED"}
          )}; */
        })
        .catch((err) => {
          if (err.response?.data?.statusCode == 500) {
            this.messages.push(
              { received: "Viky : Viky services are down!" },
              { received: err?.response?.data?.message },
              { received: "CONVERSATION_ENDED" }
            );
          } else if (
            err.response?.data?.statusCode == 500 &&
            err.response?.data?.data.errors_javascript
          ) {
            this.messages.push(
              {
                received:
                  "Viky : " +
                  err.response?.data?.data.errors_javascript?.message,
              },
              { received: "CONVERSATION_ENDED" }
            );
          } else if (err.response?.data?.code == 503) {
            this.messages.push(
              { received: "Viky : Service invailable 503" },
              { received: "CONVERSATION_ENDED" }
            );
          } else {
            this.messages.push(
              {
                received:
                  "WARNING.. Some anchors aren't correct at this level!",
              },
              { received: "Think to correct them and retray again!" },
              { received: "CONVERSATION_ENDED" }
            );
          }
        });
    },
    clearContext() {
      const patientId = this.patientId ? this.patientId : this.demoPatientId;
      this.$http
        .post(
          `/projects/${this.$route.params.id}/chat/${this.userId}/patient/${patientId}`,
          {
            metadata: {
              clearContext: true,
            },
          }
        )
        .then(({ data }) => {
          this.messages = [];
        });
    },
  },
};
</script>
<style scoped>
.message {
  max-width: 200px;
  min-width: 20px;
  height: 50px;
}
.message-input,
.patient-id-input {
  height: 50px;
}
.chat-container {
  display: flex;
  flex-direction: column;
  width: 350px;
  height: 85%;
  max-height: 700px;
  /* border: 1px black solid; */
  border-radius: 1%;
}

.chat-box {
  overflow-y: scroll;
  overflow-x: hidden;
}

.patient-id-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.patient-id-input >>> input::-webkit-outer-spin-button,
.patient-id-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
